<div class="card">
  <!-- Flagged Session -->
  <p *ngIf="sessionError" class="flagged-session">
    <mat-icon class="xs">flag</mat-icon>
    {{ sessionError.message }}
    <a *ngIf="sessionError.type === 'template' && permissions.viewSessionTemplates && project?._id"
      href="#/projects/{{ project._id }}/sessionTemplate">View Session Template</a>
  </p>

  <!-- Data -->
  <ng-container *ngIf="project?._id">
    <!-- Make sure we have a project to prevent the regular list from loading before switching to the BIDS list -->
    <acquisition-list *ngIf="!projectBids || !(bidsView$ | async)" [session]="session" [collectionId]="collectionId"
      class="animated fadeInUp"></acquisition-list>
    <bids-files *ngIf="projectBids && (bidsView$ | async)" [session]="session" [collectionId]="collectionId"
      class="animated fadeInUp"></bids-files>
  </ng-container>
</div>
